export default "__VITE_ASSET__BSC3uVpS__"